import {Trans} from '@lingui/macro'
import {Link as RouterLink} from 'react-router-dom'

import {Inline, Link, Stack, Text, tokens} from '@pleo-io/telescope'

import {pxBreakpoints} from '@product-web/styles/theme'
import {useContainerQuery} from '@product-web/telescope-lab/container-queries/container'

import {VendorList} from '../../../../apps/vendor-cards/screens/spend-activation-templates/vendor-box'

export const PopularVendorsAction = () => {
    const isDesktop = useContainerQuery({
        name: 'main',
        minWidth: pxBreakpoints.tabletMedUp,
    })

    return (
        <Stack
            paddingTop={48}
            paddingBottom={isDesktop ? 0 : 48}
            data-testid="popular-vendors-action-section"
        >
            <Inline
                paddingBottom={4}
                alignItems={'center'}
                justifyContent={'space-between'}
                css={{width: '100%'}}
            >
                <Text variant="large-accent" weight="medium">
                    <Trans>Popular vendors</Trans>
                </Text>
                <Link to="/vendor-cards/popular" as={RouterLink} data-testid="vendor-cards-see-all">
                    {/* Getting the actual number will be handled in https://linear.app/pleo/issue/GAIA-1688/update-recommended-vendor-cards-page-pre-fill-vendor-card-creation */}
                    <Trans>See all (12)</Trans>
                </Link>
            </Inline>
            <Text color={'colorContentStaticQuiet'} css={{paddingBottom: tokens.spacing16}}>
                <Trans>
                    Set up vendor cards to get a real-time view of your recurring expenses in one
                    place
                </Trans>
            </Text>
            <VendorList />
        </Stack>
    )
}
